import { Component, ViewChild, inject } from '@angular/core';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';
import { AuthService } from '../../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { LogService } from 'src/app/services';

@Component({
  selector: 'kbm-user-management',
  standalone: true,
  templateUrl: './user-management.component.html',
  styleUrl: './user-management.component.scss',
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatIconModule
  ]
})
export class UserManagementComponent {

  @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger | undefined;

  authService = inject(AuthService);
  logService = inject(LogService);

  constructor(
    public dialog: MatDialog
  ) { }

  login () {
    this.dialog.open(LoginDialogComponent, {restoreFocus: false});
  }

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  logout() {
    this.authService.logout();
  }

  getUser(): string {
    return this.authService.getUserName();
  }

  isAdmin(): boolean {
    return (this.authService.getUserRoles() || []).includes('admin');
  }
  
  clearLog() {
    this.logService.clear();
  }
}

